// src/components/DownloadToast.jsx
import React, { useEffect } from "react";
import Portal from "./Portal";

export default function DownloadToast({ url, onClose }) {
  if (!url) return null;

  // Auto-dismiss after a few seconds
  useEffect(() => {
    const t = setTimeout(() => onClose?.(), 8000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <Portal>
      <div className="fixed bottom-4 left-4 z-[1000]">
        <div className="w-[360px] rounded-xl border border-slate-200 bg-white p-4 shadow-xl">
          <div className="flex items-center gap-2">
            <h2 className="text-base font-semibold text-[#003366]">
              You’re all set
            </h2>
            <span aria-hidden className="text-lg">✅</span>
          </div>

          <p className="mt-2 text-sm text-[#003366]">
            Thanks — your details were submitted successfully. Your guide is
            downloading now.
          </p>

          <p className="mt-2 text-xs text-slate-600">
            If nothing happens, use the button below to download manually.
          </p>

          <p className="mt-3 text-xs text-slate-700">
            One of the team may reach out to understand your goals and share
            tailored insights. If you’d like to speak sooner, you can{" "}
            <a
              href={
                "https://wa.me/442038852754?text=" +
                encodeURIComponent("Hi, I’d like to discuss my investment plans.")
              }
              target="_blank"
              rel="noreferrer"
              className="font-medium underline underline-offset-2 text-[#003366]"
            >
              chat with us on WhatsApp
            </a>.
          </p>

          <div className="mt-4 flex gap-2">
            <a
              href={url}
              className="inline-flex items-center rounded-lg bg-slate-900 px-3 py-1.5 text-sm font-semibold text-white"
            >
              Download again
            </a>
            <button
              type="button"
              onClick={onClose}
              className="ml-auto text-sm text-[#003366] hover:text-[#003366]"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
}
